import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Cake, MessageCircle, Send, CheckCircle2, AlertTriangle } from "lucide-react";
import { Card } from "@/components/SettingsSections";
import { TextArea } from "@/components/Bits";
import { BigButton } from "@/components/Field";
import { useFetch, fmtDate } from "@/lib/useFetch";
import { api, errMsg } from "@/lib/api";

const Item = ({ a, auto, onSent }) => {
  const send = async () => {
    try { await api.post(`/aniversarios/${a.cliente_id}/enviar`); toast.success("Mensagem enviada"); onSent(); } catch (e) { toast.error(errMsg(e)); }
  };
  const link = `https://wa.me/${a.telefone_wa || ""}?text=${encodeURIComponent(a.mensagem)}`;
  const st = a.envio?.status;
  return (
    <li className="py-3 flex items-center gap-3" data-testid={`aniv-item-${a.cliente_id}`}>
      <div className="min-w-0 flex-1">
        <p className="font-semibold truncate">{a.nome}</p>
        <p className="text-xs text-[#5C6B66]">{fmtDate(a.data_nascimento).slice(0, 5)} · {a.em_dias === 0 ? "Hoje" : `em ${a.em_dias} dia(s)`}
          {st === "enviado" && <span className="text-[#1E4D2B] font-semibold"> · enviada</span>}
          {st === "erro" && <span className="text-[#B05A40] font-semibold" title={a.envio.erro}> · falhou</span>}</p>
      </div>
      {a.em_dias === 0 && (auto
        ? <button onClick={send} className="h-11 px-3 rounded-xl bg-[#1E4D2B] text-white text-sm font-semibold flex items-center gap-1" data-testid={`aniv-send-${a.cliente_id}`}><Send className="h-4 w-4" /> Enviar</button>
        : <a href={link} target="_blank" rel="noreferrer" className="h-11 px-3 rounded-xl bg-[#25D366] text-white text-sm font-semibold flex items-center gap-1" data-testid={`aniv-wa-${a.cliente_id}`}><MessageCircle className="h-4 w-4" /> WhatsApp</a>)}
    </li>
  );
};

export const AniversarioSection = () => {
  const [msg, setMsg] = useState("");
  const { data, reload } = useFetch("/aniversarios");
  useEffect(() => { api.get("/settings").then(({ data }) => setMsg(data.msg_aniversario || "")); }, []);
  const save = async () => {
    try { await api.put("/settings", { msg_aniversario: msg }); toast.success("Mensagem salva"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card title="Aniversário dos clientes" testId="aniversario-section">
      <div className={`rounded-xl p-3 mb-4 text-sm flex gap-2 ${data?.whatsapp_configurado ? "bg-[#E8F5E9] text-[#1E4D2B]" : "bg-[#FEF3C7] text-[#92400E]"}`} data-testid="aniv-wa-status">
        {data?.whatsapp_configurado ? <CheckCircle2 className="h-5 w-5 shrink-0" /> : <AlertTriangle className="h-5 w-5 shrink-0" />}
        {data?.whatsapp_configurado ? "Envio automático ativo: todos os dias às 8h (horário de Brasília)." : "Envio automático aguardando as chaves da Meta WhatsApp Cloud API. Enquanto isso, envie com 1 toque pelo WhatsApp."}
      </div>
      <TextArea label="Mensagem de felicitações" id="aniv-msg" rows={4} maxLength={900} value={msg} onChange={(e) => setMsg(e.target.value)} data-testid="aniv-msg" />
      <p className="text-xs text-[#5C6B66] mt-2">Use <b>{"{nome}"}</b> para o nome do cliente e <b>{"{empresa}"}</b> para o nome da empresa.</p>
      <BigButton className="mt-3" onClick={save} disabled={msg.trim().length < 5} data-testid="aniv-save"><Cake className="h-5 w-5" /> Salvar mensagem</BigButton>
      <p className="text-[11px] font-bold uppercase tracking-wider text-[#5C6B66] mt-6">Próximos 30 dias</p>
      {data?.itens.length === 0 && <p className="text-sm text-[#5C6B66] mt-2" data-testid="aniv-empty">Nenhum aniversariante. Cadastre a data de nascimento no cadastro do cliente.</p>}
      <ul className="divide-y divide-[#E2DDD3]" data-testid="aniv-list">{(data?.itens || []).map((a) => <Item key={a.cliente_id} a={a} auto={data.whatsapp_configurado} onSent={reload} />)}</ul>
    </Card>
  );
};
